<template>
  <div class="index">
    <div id="main">
      <el-alert type="warning" class="alert_info" v-if="!$store.state.abnormal">
        <svg class="icon iconhome_notice" aria-hidden="true">
          <use xlink:href="#iconhome_notice" />
        </svg>有异常订单需您处理，处理后师傅才能进行下一步
        <el-button type="warning" class="handle" @click="goAbnormalOrder()">立即处理</el-button>
      </el-alert>
      <div class="order_info">
        <div class="order_left">
          <div class="banner">
            <!-- <img src="../../assets/img/home_banners.png" alt /> -->
            <el-carousel height="200px">
              <el-carousel-item v-for="item in advertiseList" :key="item.id">
                <img :src="item.img" @click="goUrl(item.url)" alt />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="search-box">
            <el-button class="place_order" v-if="btnAuthority.jishiVisable" @click="speedOrder()">发布即时订单
              <el-tooltip class="item" effect="dark" content="需要货物已到达目的城市并且您已和客户确认上门时间" placement="bottom"
                popper-class="wuliutooltip jishidingd">
                <i class="el-icon-warning-outline"></i> </el-tooltip></el-button>
            <el-button class="place_order" @click="placeOrder()" v-if="btnAuthority.ordinaryVisable">发布普通订单
              <el-tooltip class="item" effect="dark" content="不需要您与客户确认上门时间，由师傅预约" placement="bottom"
                popper-class="wuliutooltip nowrap">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-button>
            <el-input class="search" v-model="searchText" @keyup.enter.native="isSearchText(searchText)"
              placeholder="订单号 / 客户手机号 / 客户姓名 / 物流单号">
              <i slot="prefix" @click="isSearchText(searchText)" class="iconfont iconhome_search"></i>
            </el-input>
          </div>

          <div class="my_order">
            <!-- <div class="order_title">
              <div class="title_left">我的订单</div>
              <div class="title_right" @click="goOrder()">
                全部订单
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </div>
            </div> -->
            <div class="my_order_content">
              <div v-if="item.status != 'ABNORMAL'" class="my_state" :class="orderText(item.status).class"
                @click="stateSwitching(item.status)" v-for="(item, index) in orderTotalQuantity" :key="index">
                <div class="state_num">
                  {{ orderTotalQuantity.status }}{{ item.number }}
                </div>
                <div class="state_text">{{ orderText(item.status).text }}</div>
              </div>
            </div>
          </div>
          <div class="abnormal_wait">
            <div class="order_title">
              <div class="title_left">
                待处理异常
                <a-badge :count="abnormalList.total || 0" :number-style="{ backgroundColor: '#f75658' }" />
              </div>
              <div class="title_right" @click="goAbnormalList()">
                查看更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </div>
            </div>
            <div class="abnormal_main">
              <div class="abnormal_item" v-for="item in abnormalList.records" @click="goAbnormalList(item.mainOrderNo)">
                <img :src="setAbnormalImg(item.abnormalImage)" alt="" />
                <div>
                  <div class="fuwuleix">
                    {{ item.goodsTypeName }} | {{ item.serviceTypeName }}
                    <span>{{ item.createTime }}</span>
                  </div>
                  <div class="abnormal_info">
                    <span>{{ item.abnormalType_dictText }}</span>
                    <i class="ellipsis">{{ item.description }}</i>
                  </div>
                </div>
              </div>
              <div class="null" v-show="abnormalList.total == 0">
                <img :src="require('@/assets/img/pic_none.png')" alt />
                <div>没有搜索到相关数据…</div>
              </div>
            </div>
          </div>

          <div class="incomplete_order">
            <div class="order_title">
              <!-- <div class="title_left">未完成订单 | 上门日历</div> -->
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="未完成订单" name="UNSETTLED"></el-tab-pane>
                <el-tab-pane label="上门日历" name="INSERVICE"></el-tab-pane>
              </el-tabs>
              <div class="title_right" @click="goOrder()">
                全部订单
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </div>
            </div>
            <!-- <div @click="handCalendar('prev-month')">上个月</div>
            <div @click="handCalendar('today')">今天</div>
            <div @click="handCalendar('next-month')">下个月</div> -->
            <div class="calendar_btn">
              <div class="calendar_text">
                <el-button :disabled="dateLoading" @click="lastMonth"><a-icon type="left-circle" /></el-button>
                <span>{{ dayjs(calendarDate).format("M月") }}</span>
                <el-button :disabled="dateLoading" @click="nextMonth"><a-icon type="right-circle" /></el-button>
              </div>
              <el-button @click="onToday" class="calendar_today">回到今日</el-button>
            </div>
            <el-calendar ref="calendar" v-model="calendarDate" :first-day-of-week="7" v-loading="dateLoading">
              <template slot="dateCell" slot-scope="{ date, data }">
                <p :class="data.isSelected ? 'is-selected' : ''" @click="handeDate(data, date)">
                  <!-- {{dayjs(data.day).format('MM-DD')}} -->
                  {{ dayjs(data.day).format("D") }}
                  <a-badge v-for="item in calendarData" v-if="
                    dayjs(data.day).format('MM-DD') == item.date &&
                    item.count != 0
                  " :count="item.count" :number-style="{ backgroundColor: '#f75658' }" />
                  <!-- <span v-for="item in calendarData" v-if="dayjs(data.day).format('MM-DD')==item.date">{{item.count}}</span> -->
                  <!-- {{ data.isSelected ? "✔️" : "" }} -->
                </p>
              </template>
            </el-calendar>
          </div>

          <!-- <div class="incomplete_order">
            <div class="order_title">
              <div class="title_left">未完成订单</div>
              <div class="title_right" @click="goOrder()">
                全部订单
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </div>
            </div>
            <div class="order_date">
              <div>周日</div>
              <div>周一</div>
              <div>周二</div>
              <div>周三</div>
              <div>周四</div>
              <div>周五</div>
              <div>周六</div>
            </div>
            <div class="date_info">
              <svg
                class="icon iconhome_rili_more"
                @click="lastWeek()"
                aria-hidden="true"
              >
                <use xlink:href="#iconhome_rili_more" />
              </svg>
              <div
                class="date_time"
                :class="{ selected: item.isSelected }"
                v-for="(item, index) in dateData"
                :key="index"
                @click="orderSearch(item)"
              >
                <div
                  class="date_day"
                  :class="{ today: item.date == new Date().format('MM-dd') }"
                >
                  {{
                    item.date == new Date().format("MM-dd") ? "今天" : item.day
                  }}
                </div>
                <div
                  class="order_num"
                  :class="{ zero: item.date == new Date().format('MM-dd') }"
                >
                  （{{ item.count }}）
                </div>
              </div>
              <svg
                class="icon iconhome_rili_more rili_right"
                @click="nextWeek()"
                aria-hidden="true"
              >
                <use xlink:href="#iconhome_rili_more" />
              </svg>
            </div>
          </div> -->
          <div class="index_page">
            <order-list ref="orderList" :orderItems="orderItems" :home="true" v-on:pagesize="pagesize"
              @ok="orderSearch(dateInfo)"></order-list>
          </div>
        </div>
        <div class="order_right">
          <div class="balance">
            <div class="order_title">
              <div class="title_left">账户余额</div>
              <div class="title_right" @click="openWallet()">
                更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </div>
            </div>
            <div class="balance_info">
              <div class="balance_pirce">
                {{ balance.toString().split(".")[0] }}
                <span class="dian">.</span>
                <span class="dianhou">
                  {{
                      balance.toString().split(".")[1] == null
                        ? "00"
                        : balance.toString().split(".")[1]
                  }}
                </span>
                <span class="company">元</span>
              </div>
              <div class="recharge" @click="openRecharge()">充值</div>
            </div>
          </div>
          <div class="gaiyuetixing platform_notice">
            <div class="order_title">
              <div class="title_left">
                改约提醒<el-tooltip class="item" effect="dark" content="您订单要求的服务时段无师傅提供服务，可改约到有师傅的时段或重新下单"
                  placement="bottom" popper-class="wuliutooltip gaiyue">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <router-link :to="{
                path: '/user/message',
                name: 'userMessage',
                params: { type: '改约' },
              }" class="title_right">
                更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </router-link>
            </div>
            <template v-if="mesList.total">
              <div class="gaiyue_card" v-for="item in mesList.rows">
                <div class="gaiyue_tit">
                  <div class="ellipsis">
                    <el-tooltip class="item" effect="dark" :content="item.orderInfo.customerName" placement="bottom">
                    <i class="ellipsis">
                      {{ item.orderInfo.customerName }}
                    </i>
                  </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="item.orderInfo.address" placement="bottom">
                      <span class="ellipsis">{{ item.orderInfo.address }}</span>
                    </el-tooltip>
                  </div>
                  <div class="gaiyue_tab">无人接单</div>
                </div>
                <div class="gaiyue_lable ellipsis">
                  <span>服务类型：</span>{{ item.orderInfo.goodsTypeName }} |
                  {{ item.orderInfo.serviceTypeName }}
                </div>
                <!-- <template v-if="i != 3">
                <div class="gaiyue_lable ellipsis">
                  <span>匹配到：</span>今日 09:00-12:00
                </div>
                <div class="gaiyue_lable ellipsis gaiyue_time">
                  <span>剩余时间 999分钟</span>
                </div>
              </template> -->
                <div class="bottom_box">
                  <span>{{
                      dayjs(item.createTime).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                  <div class="btn" v-if="item.orderInfo.orderType == 'TIMELY'">
                    <el-button @click="copyOrder(item.orderInfo)">重新下单</el-button>
                  </div>
                </div>
              </div>
            </template>
            <div class="notice_info null-text" v-else>暂无内容</div>
          </div>
          <div class="logistics_info platform_notice">
            <div class="order_title">
              <div class="title_left">物流信息</div>
              <router-link to="/user/order" class="title_right">
                更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </router-link>
            </div>
            <template v-if="Number(logisticsList.total)">
              <div class="logistics_label" v-for="item in logisticsList.records" @click="openOrderInfo(item)">
                <div class="left">
                  <img src="@/assets/img/home_banners.png" alt="" />
                  <div>{{ setWuliuMessage(item.wuliuMessage).status }}</div>
                </div>
                <div class="right">
                  <div class="wuliuxinxi">
                    <div class="ellipsis">
                      <i class="ellipsis">{{ item.customerName }}</i><span class="ellipsis">{{ item.address || "/"
                      }}</span>
                    </div>
                    <span class="wuliushij">{{
                        item.wuliuEarlyUpdateTime
                    }}</span>
                  </div>
                  <div class="wuliuweiz ellipsis">
                    {{ setWuliuMessage(item.wuliuMessage).text || "/" }}
                  </div>
                </div>
              </div>
            </template>
            <div class="notice_info null-text" v-else>暂无内容</div>
          </div>
          <div class="platform_notice">
            <div class="order_title">
              <div class="title_left">平台公告</div>
              <router-link to="/user/notice" class="title_right">
                更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </router-link>
            </div>
            <div class="notice_info" v-if="noticeList.totalCount != 0">
              <ul>
                <li v-for="(item, index) in noticeList.pageList" :key="index" @click="openDetail(item)">
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="notice_info null-text" v-else>暂无内容</div>
          </div>
          <div class="help_center platform_notice">
            <div class="order_title">
              <div class="title_left">帮助中心</div>
              <router-link to="/user/help" class="title_right" tag="div">
                更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconhome_title_more" />
                </svg>
              </router-link>
            </div>
            <div class="help_center_info notice_info" v-if="noticeList.totalCount != 0">
              <ul>
                <li v-for="(item, index) in helpList.pageList" :key="index" @click="goNotice(item)">
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="notice_info null-text" v-else>暂无内容</div>
          </div>
        </div>
      </div>
    </div>
    <orderInfo-modal ref="orderInfoModal"></orderInfo-modal>
  </div>
</template>

<script>
import orderList from "./order_list";
import { getAction, postAction } from "@/api/manage";
import { LOGISTICS_TYPE } from "@/utils/constant";
import dayjs from "dayjs";
import { copyMixins } from "@/mixins/copyMixins";
import orderInfoModal from "./modules/orderInfoModal";
import { imgOrVideo } from "@/utils/util";

export default {
  mixins: [copyMixins],
  components: {
    orderList,
    orderInfoModal,
  },
  data() {
    return {
      calendarDate: new Date(),
      activeName: "UNSETTLED",
      searchText: "",
      orderItems: {},
      page: 1,
      balance: 0,
      noticeList: {
        pageList: [],
        totalCount: 0,
      }, // 平台公告
      helpList: {
        pageList: [],
        totalCount: 0,
      }, // 帮助中心
      orderTotalQuantity: {}, // 订单统计数量
      dateData: [],
      dateInfo: {},
      offset: 0, // 未完成订单的偏移值
      btnAuthority: {},
      logisticsList: {
        records: [],
      },
      abnormalList: {
        records: [],
      },
      mesList: {
        rows: [],
      },
      calendarData: [],
      dateLoading: false,
      advertiseList: [],
    };
  },
  mounted() {
    var _this = this;
    for (let i of _this.$store.state.headerTabList) {
      i.isSelected = false;
      if (i.name == "首页") {
        i.isSelected = true;
      }
    }
    // // 用户信息
    // this.$fetch(`/user/api/customer`).then(res => {
    //   if (res.code == 0) {
    //     _this.$store.state.userName = res.data.nickname;
    //     _this.$store.state.userPhone = res.data.username;
    //     _this.$store.state.userAvatar = res.data.avatar;
    //     _this.$store.state.hasPwd = res.data.hasPwd;
    //     _this.$store.state.userInfo = res.data;
    //   } else {
    //     // this.$message(res.message);
    //   }
    // });
    if (Cookies.get("token") != undefined) {
      _this.orderSearch();
      // _this.getDate();
      _this.getBalance();
      _this.getNotice();
      _this.getHelp();
      _this.getOrderTotalQuantity();
      _this.getButtonAuthority();
      this.getLogisticsList();
      this.getAbnormalList();
      this.getMesList();
      this.getStats();
      this.getCarousel();
    }
  },
  methods: {
    dayjs,
    imgOrVideo,
    // 跳转订单详情
    openOrderInfo(item) {
      this.$refs.orderInfoModal.open({ id: item.orderId }, false);
    },
    goUrl(url) {
      if (url) window.open(url, "_black");
    },
    // 获取首页轮播
    async getCarousel() {
      const { data } = await getAction("/common/advertise/list", {
        location: "user_customer_home_page",
        status: "1",
        pageNo: 1,
        pageSize: 50,
      });
      console.log(data);
      this.advertiseList = data.data.pageList.filter((i) => i.status == 1);
    },
    // 获取日期统计
    async getStats() {
      try {
        this.dateLoading = true;
        const { data } = await postAction(
          "/order/api/order/stats",
          this.$qs.stringify({
            type: 2,
            offset: this.offset,
            status: this.activeName,
          })
        );
        this.calendarData = data.data;
      } finally {
        this.dateLoading = false;
      }
    },
    // 回到今日
    onToday() {
      this.offset = 0;
      this.handCalendar("today");
      this.getStats();
      this.handeDate({}, null);
    },
    // 上一月的数据
    lastMonth() {
      this.offset = this.offset - 1;
      this.getStats();
      this.handCalendar("prev-month");
    },
    // 下一月的数据
    nextMonth() {
      this.offset = this.offset + 1;
      this.getStats();
      this.handCalendar("next-month");
    },
    // 获取改约提醒
    async getMesList() {
      const { data } = await postAction(
        "/order/api/order/mes/list",
        this.$qs.stringify({
          pageIndex: 1,
          pageSize: 3,
          title: "无人接单",
        })
      );
      this.mesList = data.data.pageResult;
    },
    // 跳转异常记录
    goAbnormalList(orderNo) {
      this.$router.push({
        name: "followupRecord",
        params: {
          type: 1,
          orderNo: orderNo,
        },
      });
    },
    // 设置异常图片
    setAbnormalImg(imgs) {
      if (imgs){
        let temObj=imgOrVideo(imgs.split(",")[0])
        let url= temObj.type=='video'?temObj.url+'?x-oss-process=video/snapshot,t_2000,f_jpg,w_800,h_600,m_fast':temObj.url
        return url
      }else return require("@/assets/img/tem_abnormal.png");
    },
    // 获取待处理异常
    async getAbnormalList() {
      const { data } = await getAction("/order/api/abnormal/list", {
        pageNo: 1,
        pageSize: 4,
        merchantStatus: "FOLLOWING_UP",
      });
      this.abnormalList = data.data;
    },
    // 设置物流信息
    setWuliuMessage(data) {
      let info = JSON.parse(data);
      return { text: info.data[0].context, status: LOGISTICS_TYPE[info.state] };
    },
    // 获取物流信息
    async getLogisticsList() {
      const { data } = await getAction("/order/api/order/logistics_list", {
        pageNo: 1,
        pageSize: 4,
      });
      this.logisticsList = data.data;
    },
    // 切换日历时间
    handCalendar(type) {
      this.$refs.calendar.selectDate(type);
    },
    // 选择日期
    handeDate(data, date) {
      this.orderSearch(date);
    },
    handleClick() {
      this.getStats();
    },
    // 获取下单按钮权限
    getButtonAuthority() {
      getAction("/user/api/customer/button_control").then(({ data }) => {
        if (data.code == 0) {
          this.btnAuthority = data.data;
        }
      });
    },
    // 跳转帮助中心
    goNotice(item) {
      this.$router.push({ path: "/user/help", query: { index: item.title } });
    },
    // 跳转平台公告
    openDetail(item) {
      this.$router.push({ name: "noticeDetail", params: item });
    },
    // 跳转去全部订单
    goOrder() {
      this.$router.push({ name: "allOrder",params:{isFinish:false} });
    },
    // 跳转异常订单
    goAbnormalOrder() {
      this.$router.push({ name: "allOrder", params: { status: "ABNORMAL" } });
    },
    // 根据搜索条件跳转全部订单
    isSearchText(item) {
      var myreg = /^1[123456789]\d{9}$/;
      if (item == "" || item == null) {
        return;
      }
      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");

      if (myreg.test(item)) {
        console.log("手机号");
        this.$router.push({ name: "allOrder", params: { customer: item } });
        return;
      }
      if (!isNaN(item) && item.toString().length == 14) {
        console.log("订单号");
        return this.$router.push({
          name: "allOrder",
          params: { orderNum: item },
        });
      }

      if (reg.test(item)) {
        console.log("姓名");
        this.$router.push({ name: "allOrder", params: { customer: item } });
      } else {
        console.log("物流单号");
        this.$router.push({ name: "allOrder", params: { logisticsNo: item } });
      }
    },
    // 根据不同状态获取不同列表
    stateSwitching(val) {
      this.status = val;
      if (val == "MARKUP_WAIT_PAY")
        return this.$router.push({
          name: "followupRecord",
          params: { status: val },
        });
      this.$router.push({ name: "allOrder", params: { status: val } });
    },
    // 获取订单状态统计
    getOrderTotalQuantity() {
      let _this = this;
      this.$fetch(`/order/api/order/stats_status`).then((res) => {
        if (res.code == 0) {
          _this.orderTotalQuantity = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取余额
    getBalance() {
      let _this = this;
      this.$fetch(`/user/api/customer/balance`).then((res) => {
        if (res.code == 0) {
          _this.balance = res.data.balance;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取平台公告列表
    getNotice() {
      var _this = this;
      this.$fetch(
        `/common/api/article?pageIndex=1&pageSize=3&typeCode=notice`
      ).then((res) => {
        if (res.code == 0) {
          _this.noticeList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取帮助中心
    getHelp() {
      var _this = this;
      this.$fetch(
        `/common/api/article?pageIndex=1&pageSize=3&typeCode=help`
      ).then((res) => {
        if (res.code == 0) {
          _this.helpList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 根据订单状态返回数据
    orderText(item) {
      let data = {};
      if (item == "WAIT_PAY") {
        data.text = "待支付";
        data.class = "dz";
        return data;
      }
      if (item == "NOT_ARRIVAL") {
        data.text = "未到货";
        data.class = "wd";
        return data;
      }
      if (item == "INSERVICE") {
        data.text = "服务中";
        data.class = "fw";
        return data;
      }
      if (item == "WAIT_ACCEPT") {
        data.text = "待验收";
        data.class = "dy";
        return data;
      }
      // if (item == "ABNORMAL") {
      //   data.text = "异常订单";
      //   data.class = "yc";
      //   return data;
      // }
      if (item == "WAIT_EVALUATE") {
        data.text = "待评价";
        data.class = "dp";
        return data;
      }
      if (item == "MARKUP_WAIT_PAY") {
        data.text = "加价未支付";
        data.class = "yc";
        return data;
      }
    },
    // 跳转我的钱包
    openWallet() {
      this.$router.push({ path: "/user/wallet" });
    },
    // 跳转充值
    openRecharge() {
      this.$router.push({ path: "/user/wallet/recharge" });
    },
    placeOrder() {
      this.$router.push({ path: "/placeorder/stepone" });
    },
    // 即时下单
    speedOrder() {
      this.$router.push({ name: "speedOrder" });
    },
    pagesize(val) {
      this.page = val;
      this.orderSearch(this.dateInfo);
    },
    orderSearch(item) {
      console.log(item);
      this.dateInfo = item;

      var _this = this;
      var params = {};
      this.$refs.orderList.loading = true;
      if (this.dateInfo != undefined) {
        if (this.activeName == "UNSETTLED") {
          params.startTime = new Date(this.dateInfo).format(
            "yyyy-MM-dd HH:mm:ss"
          );
          params.endTime =
            new Date(this.dateInfo).format("yyyy-MM-dd") + " 23:59:59";
        }
        if (this.activeName == "INSERVICE") {
          params.appointStartTime = new Date(this.dateInfo).format(
            "yyyy-MM-dd HH:mm:ss"
          );
          params.appointEndTime =
            new Date(this.dateInfo).format("yyyy-MM-dd") + " 23:59:59";
        }

        params.status = this.activeName;
      } else {
        // params.startTime = new Date().format("yyyy-MM-dd") + " 00:00:00";
        // params.endTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
        if (this.activeName == "UNSETTLED") {
          params.startTime = new Date().format("yyyy-MM-dd") + " 00:00:00";
          params.endTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
        }
        if (this.activeName == "INSERVICE") {
          params.appointStartTime =
            new Date().format("yyyy-MM-dd") + " 00:00:00";
          params.appointEndTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
        }
        params.status = this.activeName;
      }
      params.pageNum = _this.page;
      params.pageSize = "6";
      this.$fetch(`/order/api/order`, params)
        .then((res) => {
          if (res.code == 0) {
            _this.orderItems = res.data;
          } else {
            this.$message(res.message);
          }
        })
        .finally(() => {
          this.$refs.orderList.loading = false;
        });
    },
    // 上一周的数据
    lastWeek() {
      this.offset = this.offset - 1;
      this.getDate();
    },
    // 下一周的数据
    nextWeek() {
      this.offset = this.offset + 1;
      this.getDate();
    },
    // 获取每周的数据
    getDate() {
      let _this = this;
      let dateData = [];
      this.$post(`/order/api/order/stats?type=1&offset=${_this.offset}`).then(
        (res) => {
          if (res.code == 0) {
            for (let i of res.data) {
              i.isSelected = false;
              i.day = i.date.split("-").join("月") + "日";
              dateData.unshift(i);
              if (i.date == new Date().format("MM-dd")) {
                i.isSelected = true;
              }
            }
            _this.dateData = dateData;
          } else {
            this.$message(res.message);
          }
        }
      );
    },
  },
};
</script>
<style lang="scss">
.wuliutooltip {
  background: #fff6e7 !important;
  color: #5e6066 !important;
  line-height: 16px;

  &.nowrap {
    max-width: 250px !important;
    width: 250px !important;
  }

  &.jishidingd {
    max-width: 309px !important;
    width: 309px !important;
  }

  &.gaiyue {
    max-width: 417px !important;
    width: 417px !important;
  }

  .popper__arrow {
    display: none !important;
  }
}

@import "./_index.scss";
</style>
<style lang="scss" scoped>
.calendar_btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 64px;
  height: 50px;

  .calendar_today {
    position: absolute;
    width: 66px;
    height: 26px;
    border-radius: 2px;
    padding: 0;
    color: #5e6066;
    font-size: 12px;
    // top: 19px;
    top: 12px;
    right: 20px;

    &:hover {
      color: #3455d3;
      border-color: #3455d3;
      background: #fff;
    }
  }

  &/deep/.calendar_text {
    color: #5e6066;

    .el-button {
      padding: 0;
      border: 0;
      background: transparent !important;
      color: transparent;
      border: 0;
    }

    .anticon {
      font-size: 21px;
      color: #5e6066;
      cursor: pointer;

      &:hover {
        color: #3455d3;
      }
    }

    &>span {
      font-size: 24px;
      font-weight: 500;
      margin: 0 26px;
    }
  }
}

.incomplete_order {
  &/deep/.el-calendar__header {
    display: none;
  }

  &/deep/.el-tabs__header {
    margin: 0;

    .el-tabs__active-bar {
      background: #3455d3;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__nav {
      height: 50px;

      .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        color: #2f3133;

        &.is-active {
          color: #3455d3;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }
}

/deep/.el-calendar {
  .ant-scroll-number-only-unit {
    background: transparent !important;
  }

  .current.is-selected {
    color: #3455d3;
    background: #d6ddf6;
  }
  .el-calendar-table{
    font-size: 16px;
  }
  .el-calendar-table td.is-selected {
    background: #d6ddf6 !important;
  }

  .el-calendar__body {
    padding: 0;
  }

  .current {
    &:hover {
      background: #f5f7fa;
    }
  }

  .is-today {
    border-top: 2px solid #3455d3;
    background: #fff;
    color: #3455d3;
    //  .el-calendar-day> p {
    //     border-top: 1px solid #3455d3;
    //     background: #fff;
    //     color: #3455d3;
    //   }
  }

  .el-calendar-day {
    // height: 48px;
    height: 40px;
    padding: 0;

    &:hover {
      background-color: transparent;
    }

    &>p {
      // height: 48px;
      height: 40px;
      padding: 8px 0 0 24px;
      position: relative;

      .ant-badge {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  thead {
    background: #f9fafa;

    th {
      padding-left: 24px;
      color: #666666;
      font-size: 16px;
    }
  }
}

.order_info {
  margin-bottom: 15px;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.title_left {
  display: flex;
  align-items: center;
}

.abnormal_wait {
  background: #fff;
  margin-top: 15px;
  padding-bottom: 20px;

  &/deep/.ant-badge {
    margin-left: 4px;
  }

  .abnormal_main {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 7px 20px 0;

    .null {
      padding: 30px 261px;
      background: #fff;
      text-align: center;

      img {
        width: 375px;
        height: 94px;
      }

      div {
        color: #b4b7bc;
        font-size: 14px;
        margin-top: 8px;
        text-align: center;
      }
    }

    .abnormal_item {
      margin-top: 16px;
      width: 420px;
      display: flex;
      align-items: center;
      cursor: pointer;

      &>div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;

        .fuwuleix {
          font-size: 12px;
          color: #5e6066;
          height: 14px;
          line-height: 14px;

          span {
            color: #909399;
            margin-left: 16px;
          }
        }

        .abnormal_info {
          display: flex;
          align-items: center;
          height: 16px;
          line-height: 16px;
          color: #2f3133;
          font-size: 12px;

          span {
            padding: 0 2px;
            border: 1px solid #3455d3;
            border-radius: 2px;
            color: #3455d3;
            margin-right: 10px;
          }

          i {
            font-style: normal;
            width: 290px;
          }
        }
      }

      img {
        width: 46px;
        height: 46px;
        border-radius: 2px;
        margin-right: 14px;
      }
    }
  }
}

.gaiyuetixing {
  background: #fff;

  .notice_info {
    background: transparent !important;
  }

  .el-icon-warning-outline {
    font-size: 14px;
    color: #909399;
    cursor: pointer;
    margin-left: 8px;

    &:hover {
      color: #3455d3;
    }
  }

  .gaiyue_card {
    margin: 16px 20px 0;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8eef5;

    &:last-child {
      border: 0;
    }

    .gaiyue_tit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 16px;

      &>div:first-child {
        // display: flex;
        // align-items: center;
        width: 187px;
      }

      i {
        font-style: normal;
        color: #2f3133;
        line-height: 14px;
        font-size: 14px;
        max-width: 56px;
        display: inline-block;
      }

      span {
        // max-width: 127px;
        font-size: 12px;
        color: #5e6066;
        margin-left: 4px;
      }

      .gaiyue_tab {
        padding: 0 4px;
        background: rgba(247, 86, 88, 0.1);
        border-radius: 2px;
        color: #f75658;
        font-size: 12px;
        height: 16px;
        line-height: 16px;
      }
    }

    .gaiyue_lable {
      display: flex;
      align-items: center;
      color: #5e6066;
      font-size: 12px;
      line-height: 12px;
      margin-top: 12px;

      &.gaiyue_time {
        margin-top: 18px;
      }

      span {
        width: 60px;
        color: #909399;
        margin-right: 1px;
      }
    }

    .bottom_box {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 12px;
      }
    }

    .btn {
      display: flex;
      justify-content: flex-end;

      &/deep/.el-button {
        width: 66px;
        height: 26px;
        border-color: #3455d3;
        border-radius: 2px;
        color: #3455d3;
        font-size: 12px;
        padding: 0;
      }
    }
  }
}

.logistics_info {
  background: #fff;

  .notice_info {
    background: transparent !important;
  }

  .logistics_label {
    display: flex;
    justify-content: space-between;
    margin: 20px 20px 0;
    cursor: pointer;

    &:last-child {
      padding-bottom: 20px;
    }

    .left {
      // width: 36px;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      div {
        font-size: 12px;
        border-radius: 2px;
        border: 0.5px solid #3455d3;
        padding: 0 2px;
        display: inline-flex;
        align-items: center;
        color: #3455d3;
        margin-top: 7px;
      }

      img {
        width: 36px;
        height: 36px;
        border-radius: 2px;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &>div {
        width: 199px;
      }

      .wuliuxinxi {
        &>div {
          line-height: 14px;

          i {
            font-style: normal;
            color: #2f3133;
            line-height: 14px;
            font-size: 14px;
            max-width: 56px;
            display: inline-block;
          }

          span {
            font-size: 12px;
            color: #909399;
            margin-left: 4px;
          }
        }

        .wuliushij {
          font-size: 12px;
          color: #909399;
          line-height: 12px;
          margin-top: 8px;
          display: inline-flex;
        }
      }

      .wuliuweiz {
        color: #5e6066;
        font-size: 12px;
      }
    }
  }
}

.index_page {
  /deep/.order-bottom {
    padding: 0 14px !important;
  }

  /deep/.add-remark {
    &>div span {
      width: 715px;
    }
  }

  /deep/ #orderlist {
    .commodity .com_info {
      width: 155px;
    }
  }
}

.search {
  &/deep/input {
    padding: 9px 0;
  }
}

/deep/.banner {
  margin-top: 0 !important;

  .el-carousel__arrow {
    width: 26px;
    height: 60px;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.5);

    i {
      font-size: 24px;
    }

    &.el-carousel__arrow--left {
      left: 0;
    }

    &.el-carousel__arrow--right {
      right: 0;
    }
  }

  img {
    cursor: pointer;
  }
}

.search-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .search {
    margin-bottom: 0 !important;
    flex: 1;
    margin-left: 11px;
  }

  .place_order {
    background: #3455d3;
    border-radius: 0;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    padding: 11px 0;
    width: 149px;
    height: 44px;
    border: 0;
  }

  .place_order+.place_order {
    background: #d6ddf6;
    color: #3455d3;
    margin-left: 16px;
    // margin-right: 11px;
  }
}
</style>
